module.exports = __webpack_public_path__ + "static/media/prensa.d34390de.jpg";